export const formatBool = value => (value?.toString() === 'true' ? 'Yes' : 'No');

export function noop<T>(id: T) {
  return id;
}
